import useAccountPermissions from "utils/useAccountPermissions";

const useController = () => {
	const { isAdmin } = useAccountPermissions();

	return { isAdmin };
};

export default useController;
